module.exports = __webpack_public_path__ + "img/dp-sy-zt3.39912ea5.png";